import "./assessment-template-buttons.scss";

import { observer } from "mobx-react";
import React, { useState } from "react";

import { Button } from "@/components/Elements";

import ButtonWithConfirmation from "../components/ButtonWithConfirmation/ButtonWithConfirmation";

type AssessmentTemplateContextMenuProps = {
  onCopy: () => void;
  onDelete: () => void;
};

function AssessmentTemplateButtons({
  onCopy,
  onDelete,
}: AssessmentTemplateContextMenuProps) {
  // In use for all actions as deleting and copying are not possible at the same time
  const [isDisabled, setIsDisabled] = useState(false);

  const onCopyHandler = async () => {
    setIsDisabled(true);
    await onCopy();
    setIsDisabled(false);
  };

  const onDeleteHandler = async () => {
    setIsDisabled(true);
    await onDelete();
    setIsDisabled(false);
  };

  return (
    <>
      <Button
        label="Duplicate"
        onClick={onCopyHandler}
        theme="tertiary"
        disabled={isDisabled}
      />
      <div className="space-between-buttons" />
      <ButtonWithConfirmation
        buttonLabel="Delete"
        isDisabled={isDisabled}
        onConfirm={onDeleteHandler}
        confirmationHeading="Assessment Removal"
        confirmationContent="The assessment template is about to be removed. The assigned partners will be able to fill this out but the assessment will no longer be available. Are you sure?"
      />
    </>
  );
}

export default observer(AssessmentTemplateButtons);
